import EnergyIcon from '@/assets/icons/energy-light.svg'
import { ENERGY_BADGE_ID } from '@/constants'

import { Container, CountText, DisabledIcon, LabelText } from './styles'

interface EnergyBadgeProps {
  count: number
}

export default function EnergyBadge({ count }: EnergyBadgeProps) {
  const isDisabled = count === 0

  return (
    <Container
      id={ENERGY_BADGE_ID}
      isDisabled={isDisabled}>
      {isDisabled ? <DisabledIcon /> : <img src={EnergyIcon} alt='' width={20} height={20} />}
      <LabelText>내 에너지</LabelText>
      <CountText>{count}개</CountText>
    </Container>
  )
}
